module.exports = __webpack_public_path__ + "static/media/hnl.static.2b218fad.svg";